module.exports = __webpack_public_path__ + "img/button_bottom.aa4954a3.png";